<template>
  <div class="app-input-group">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppInputGroup',
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@use '@/styles/settings.scss' as *;

.app-input-group {
  $borderRadius: math.div($defaultBorderRadius, 2);
  display: flex;
  border-radius: $borderRadius;
  overflow: hidden;

  > .app-input {
    flex: 1;
  }

  > * {
    border-radius: 0;

    &:first-child,
    &:last-child {
      &:not(.app-input) {
        $padding: #{math.div($defaultPadding, 1.5)};
        background-color: rgba(0, 0, 0, 0.075);
        color: rgba(0, 0, 0, 0.55);
        padding-left: $padding;
        padding-right: $padding;
        box-sizing: content-box;
      }
    }

    &:first-child {
      border-top-left-radius: $borderRadius;
      border-bottom-left-radius: $borderRadius;
    }

    &:last-child {
      border-top-right-radius: $borderRadius;
      border-bottom-right-radius: $borderRadius;
    }

    &.app-input {
      &:not(:first-child) {
        padding-left: 0;
      }

      &:not(:last-child) {
        padding-right: 0;
      }
    }
  }

  &.app-input-focused {
    > * {
      &:first-child,
      &:last-child {
        &:not(.app-input) {
          color: $primaryColor;
          background-color: rgba($primaryColor, 0.1);
        }
      }
    }
  }
}
</style>
